import { api } from './api';
import { useApi } from './use-api-call';
import { CategoryDTO } from './category-api';
import { ProductSpecificationDTO } from './product-specification-api';
import { ProductFeatureDTO } from './product-feature-api';
import { ProductPostPurchaseFeatureDTO } from './product-post-purchase-feature-api';

export const useSearchProductApi = () =>
    useApi<{
        products: ProductDTO[];
        categories: CategoryDTO[];
        allowEdit: boolean;
    }>('/product/search-product');

export const useGetProductApi = () =>
    useApi<{ product: ProductDTO; allowEdit: boolean }>('/product/get-product/{id}');

export const saveProductApi = (product: ProductDTO, onProgress?: (percent: number) => void) =>
    api.upload('/product/save-product', product.file, product, onProgress);

export const useDeleteProductApi = () => useApi('/product/delete-product/{id}');

export interface ProductDTO {
    id?: number;
    attachmentId?: number;
    name: string;
    categoryCode: string;
    features: ProductFeatureDTO[];
    specifications: ProductSpecificationDTO[];
    postPurchaseFeatures: ProductPostPurchaseFeatureDTO[];
    file: File;
    enable: boolean;
    description?: string;
    createdAt?: Date;
}
